const initialState = null;

export const invitesReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    default:
      return state;
  }
};
